import { FunctionComponent } from 'react';
import { View, Card, InfoIcon, Text, Link } from '@upstox/upstox-ui';
import * as css from './InfoCard.style';

type Props = {
  showLink?: boolean;
  linkText?: string;
  description?: string;
};

const InfoCard: FunctionComponent<Props> = ({
  showLink,
  linkText,
  description,
}) => {
  return (
    <Card width="full" style={{ borderRadius: '8px' }}>
      <View alignItems="center" css={css.preApplyCard}>
        <View css={css.preApplyIcon}>
          <InfoIcon size="small" color="text.2" />
        </View>
        <View alignItems="center" flexWrap="wrap" css={css.preApplyLink}>
          <Text size="s">{description}</Text>
          {showLink && (
            <a
              target="_blank"
              href="https://help.upstox.com/support/solutions/articles/251757-what-is-pre-apply-for-an-ipo-and-how-does-it-work-"
            >
              <Text color="text.link" variant="meta" className="ml3">
                {linkText}
              </Text>
            </a>
          )}
        </View>
      </View>
    </Card>
  );
};

export default InfoCard;
